import React, { useEffect, useState } from "react";
import MessageAY3 from './MessageAY3';
import MessageA1i from './MessageA1i';
import LoadingSpinner from "../Lottie/LoadingSpinner";


const MessageA3i = (probs) => {
    const { item, array, addMessages, setisSubscriber ,scrollToBottom } = probs

    const [loader, setLoader] = useState(false);

    useEffect(() => {

        setLoader(true);
        setTimeout(() => {

            setLoader(false);


        }, 3000); // 3 seconds loader
    }, [])

    useEffect(() => {
        scrollToBottom()
    }, [loader])
    return (
        <div>
            {loader && <LoadingSpinner />}
            {!loader && <div style={{ width: "fit-content" }}>
                <div
                    id="main-tab1"
                    style={{ padding: '4px' }}
                    className='A3f'
                    dangerouslySetInnerHTML={{ __html: item?.text }}  // Allowing raw HTML
                />

            </div>}
            {!loader && array?.map((item, index) => {
                return (
                    <React.Fragment key={item?.id || index}> {/* Ensure a unique key for each child */}
                        {(item?.uiCommand === "A1i" || item?.uiCommand === "A1") && (
                            <div style={{ display: "inline-block" }}>
                                <MessageA1i
                                    item={item}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    loader={loader}
                                />
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    )
}

export default MessageA3i
